import request from '@/utils/request'
import type { CommerceItem } from './type'

export function getCommerceListApi() {
  return request<CommerceItem[]>({
    url: 'commerce/list',
  })
}

export function getCommerceTrendApi(params: { commerceId: number }) {
  return request<CommerceItem[]>({
    url: 'commerce/getTrend',
    params,
  })
}
